import { Create, SimpleForm } from 'react-admin';
import { MyFormContainer, MyToolbar } from '@/components/forms';
import { PlanFormFields } from './PlanForm';

export const PlanCreate = () => (
  <Create redirect="list">
    <SimpleForm toolbar={<MyToolbar resource="plans" />}>
      <MyFormContainer>
        <PlanFormFields isCreate />
      </MyFormContainer>
    </SimpleForm>
  </Create>
);

export default PlanCreate;
